import * as React from "react";
import classnames from "classnames";
import { Spinner } from "@grandvisionhq/iris-ui";
import { useIntl } from "@grandvisionhq/state";
import LocationList from "../../../LocationList/components/LocationList/LocationList.js";
/* empty css                        */
const LocationSearchList = ({ children, className, loading, ...rest }) => {
  const { getLabel } = useIntl();
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("location-search-list", className) }, loading ? /* @__PURE__ */ React.createElement("div", { className: "location-search-list__loader" }, /* @__PURE__ */ React.createElement(Spinner, { "aria-label": getLabel("common.loadingText") })) : /* @__PURE__ */ React.createElement(LocationList, null, children));
};
export {
  LocationSearchList as default
};
//# sourceMappingURL=LocationSearchList.js.map
